import script from "./SubtopicVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./SubtopicVideo.vue?vue&type=script&setup=true&lang=js"

import "./SubtopicVideo.vue?vue&type=style&index=0&id=8193d6c0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8193d6c0"]])

export default __exports__